"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailValid = void 0;

var isEmailValid = function isEmailValid(localEmail) {
  // is email field filled?
  if (!localEmail) {
    return false;
  } // does email contain characters before and after @


  var validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return validEmailRegex.test(localEmail);
};

exports.isEmailValid = isEmailValid;